import { render, staticRenderFns } from "./blockchain_w.vue?vue&type=template&id=507c49a4&scoped=true"
import script from "./blockchain_w.vue?vue&type=script&lang=js"
export * from "./blockchain_w.vue?vue&type=script&lang=js"
import style0 from "./blockchain_w.vue?vue&type=style&index=0&id=507c49a4&prod&scoped=true&lang=css"
import style1 from "./blockchain_w.vue?vue&type=style&index=1&id=507c49a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c49a4",
  null
  
)

export default component.exports